/**
 * voice / emotion code → 사용자 친화 한글 라벨 매핑 (2026-05-12).
 *
 * VoicePresetCard 등 카드 표시용. caller 는 `getVoiceLabel` / `getEmotionLabel` 만 사용.
 *
 * 매핑 범위 (1차):
 * - voice: V20260432 시드 14 + Hayul + Jisoo = 16. 나머지 `DtoVoice` 항목은 fallback = raw code.
 *   영문 voice 는 음역, 한국이름은 그대로.
 * - emotion: `DtoEmotion` 7 + `normal-1` (DB 실측 drift). 모두 한글 의미 매핑.
 *
 * 후속 PR 등록 (drive-by 회피):
 * - F-{n}: DtoVoice 30개 전체 매핑 (Sora / Sua / Ian / Hyunji / Krys / Yura 등)
 * - F-{n}: `DtoEmotion` 갱신 (`normal-1` 등 BE actual 값과 정합)
 * - F-{n}: 라벨 의미 검토 — 디자이너/카피라이터 위임. 1차 음역 라벨 vs 의미 라벨 (예: Onyx → "오닉스" vs "묵직한 톤").
 */

const VOICE_LABELS: Partial<Record<string, string>> = {
  Hayul: '하율',
  Charon: '카론',
  Inhwa: '인화',
  Onyx: '오닉스',
  Puck: '퍽',
  Yubin: '유빈',
  Coral: '코랄',
  Echo: '에코',
  Salang: '살랑',
  Sage: '세이지',
  Yeonah: '연아',
  Jisoo: '지수',
  iWLjl1zCuqXRkW6494ve: '지수',
  Laomedeia: '라오메데이아',
  Alloy: '알로이',
  Aoede: '아오에데',
  Enceladus: '엔셀라두스',
};

const EMOTION_LABELS: Partial<Record<string, string>> = {
  normal: '보통',
  'normal-1': '자연스러운',
  'shout-1': '외침',
  angry: '화남',
  'angry-1': '강한 화남',
  joy: '기쁨',
  calmness: '차분함',
  whispering: '속삭임',
};

/** 매핑 dict 미존재 시 raw code 그대로 반환 (silent fallback, console.warn 미사용). */
export const getVoiceLabel = (code: string): string =>
  VOICE_LABELS[code] ?? code;

export const getEmotionLabel = (code: string): string =>
  EMOTION_LABELS[code] ?? code;
